import Hangman from "./Hangman";
import './styles/App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
          <Hangman />
      </header>
    </div>
  );
}

export default App;
